import apiClient from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_API_ORDER_URL

export const update = async (data) => {
  const response = await apiClient({
    baseURL,
    method: 'PATCH',
    url: `/delivery-order/update`,
    data,
  })

  return response?.data
}
